export const buildFetchTeamMembersApiConfig = () => ({
    url: '/api/team-members/',
    method: 'GET',
});
